(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-in"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.featured-in-section').forEach((root) => {
      const ctaEl = root.querySelector('.js-featured-cta');
      const ctaTitleEl = root.querySelector('.js-featured-cta-title');
      const ctaMediaEl = root.querySelector('.js-featured-cta-media');
      const ctaImgEl = root.querySelector('.js-featured-cta-img');

      const sliderEl = root.querySelector('.featured-in-card__slider');
      if (!sliderEl) return;

      const swiper = new Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 600,
        autoHeight: true,
        loop: false,
        pagination: {
          el: root.querySelector('.featured-in-pagination'),
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
        },
        navigation: {
          nextEl: root.querySelector('.featured-in-next'),
          prevEl: root.querySelector('.featured-in-prev'),
          disabledClass: 'swiper-button-disabled',
        },
      });

      // Update CTA from data attributes on slide change
      swiper.on('slideChange', function () {
        const activeSlide = this.slides[this.activeIndex];
        const dataEl = activeSlide && activeSlide.querySelector('.featured-in-card__body');
        if (!dataEl || !ctaEl) return;

        const link = dataEl.getAttribute('data-product-link');
        const title = dataEl.getAttribute('data-link-title');
        const img = dataEl.getAttribute('data-link-image');

        if (link) ctaEl.setAttribute('href', link);
        if (title && ctaTitleEl) ctaTitleEl.textContent = title;
        if (img && ctaImgEl) {
          // Ensure the browser swaps the image even if the original tag had srcset/sizes
          ctaImgEl.removeAttribute('srcset');
          ctaImgEl.removeAttribute('sizes');
          ctaImgEl.setAttribute('src', img);
          const alt = dataEl.getAttribute('data-link-image-alt') || title || '';
          ctaImgEl.setAttribute('alt', alt);
          if (ctaMediaEl) ctaMediaEl.style.display = '';
        } else if (!img && ctaMediaEl) {
          // Hide media when slide does not provide an image
          ctaMediaEl.style.display = 'none';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // Gorgias Chat Toggle Functionality
  let toggleChat = 1;
  const supportButton = document.querySelector('[id^="support-button-footer-"]');

  if (supportButton) {
    supportButton.addEventListener('click', async (event) => {
      event.preventDefault();

      if (toggleChat % 2 == 1) {
        const opened =
          typeof openSupportChat === 'function'
            ? await openSupportChat()
            : typeof GorgiasChat !== 'undefined' && GorgiasChat.open && (GorgiasChat.open(), true);
        if (opened) supportButton.textContent = 'Close Chat';
      } else {
        const closed =
          typeof closeSupportChat === 'function'
            ? await closeSupportChat()
            : typeof GorgiasChat !== 'undefined' && GorgiasChat.close && (GorgiasChat.close(), true);
        if (closed) supportButton.textContent = 'Support';
      }

      toggleChat++;
    });
  }

  const observer = new MutationObserver(function (mutationRecords) {
    for (const mutation of mutationRecords) {
      if (mutation.addedNodes[0] && mutation.addedNodes[0].id === 'gorgias-chat-container') {
        const supportBtn = document.querySelector('[id^="support-button-footer-"]');
        if (supportBtn) {
          supportBtn.textContent = 'Support';
        }
      }
    }
  });

  observer.observe(document.body, { childList: true });

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucy-collections-2x2"] && !Shopify.designMode) return;
  try {
    
  const POUCHES_SID = "7099121893562";
  const GUM_SID = "7100963684538";
  const LOZENGE_SID = "7321365577914";
  const BREAKERS_SID = "7099088076986";

  const url = `https://api.juniphq.com/v1/products?filter[remote_ids]=${POUCHES_SID},${GUM_SID},${LOZENGE_SID},${BREAKERS_SID}`;

  window.addEventListener('DOMContentLoaded', () => {
    fetch(url, {
      method: "GET",
      headers: { "Junip-Store-Key" : "von5ggVc3op5TN8Z2yo9iiVK" }
    })
    .then(response => response.json()) 
    .then(json => {
      json.products.forEach(product => {
        set(product.remote_handle, JSON.stringify(product), 86400);
        if(document.querySelector(`.${product.remote_handle}`)) {
          document.querySelector(`.${product.remote_handle}.recommended-count`).innerText = `(${product.recommended_count})`;
          document.querySelector(`.${product.remote_handle}.overlay`).style.width = `${(((5 - product.rating_average) / 5) * 100)}%`
        };
      });
    })
    .catch(err => console.log(err));
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucy-discount"] && !Shopify.designMode) return;
  try {
    
const discountCodeBar = document.querySelector('#discount-code');
const announcementBar = document.querySelector('#shopify-section-announcement-bar');

window.addEventListener('DOMContentLoaded', () => {
  const discountCode = getCookie("discount_code");

  if(discountCode === 'barstool') {
    discountCodeBar.classList.remove('xhidden');
    if(window.innerWidth < 780) {
      announcementBar.classList.add('xhidden');
    }
  } else {
    discountCodeBar.classList.add('xhidden');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucy-home-three-copy"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  // const swiper = new Swiper('.swiper-three-copy', {
  //   // Optional parameters
  //   direction: 'horizontal',
  //   loop: false,
  //   slidesPerView: 1,
  //   spaceBetween: 0,
  //   centeredSlides: true,
  //   pagination: {
  //     el: '.swiper-pagination',
  //     clickable: true
  //   },
  //   navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev',
  //   },
  // });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucy-homepage-junip"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucy-modal"] && !Shopify.designMode) return;
  try {
    
  // Don't show modals in theme editor
  if (window.Shopify && window.Shopify.designMode) {
    return;
  }

  const body = document.querySelector('body');
  const ageModal = document.querySelector('#ageModal');
  const countryModalCA = document.querySelector('#countryModalCA');
  const countryModalUK = document.querySelector('#countryModalUK');

  async function setCountryCookies() {
    const res = await fetch(
      window.Shopify.routes.root +
        'browsing_context_suggestions.json' +
        '?country[enabled]=true' +
        `&country[exclude]=${window.Shopify.country}` +
        '&language[enabled]=true' +
        `&language[exclude]=${window.Shopify.language}`
    )
      .then((r) => r.json()) // Parse the JSON from the response and return it
      .then((data) => {
        return data;
      });
    const country = res.detected_values.country.name;
    // const country = 'Canada';

    if (country === 'Canada') {
      // body.classList.add('overflow-hidden');
      // countryModalCA.classList.remove('xhidden');
      // countryModalCA.classList.remove('modal-hidden');
      window.location.href = 'https://ca.lucy.co/?source=modal';
    } else if (country === 'United Kingdom') {
      body.classList.add('overflow-hidden');
      countryModalUK.classList.remove('xhidden');
      countryModalUK.classList.remove('modal-hidden');
    }
  }

  window.addEventListener('DOMContentLoaded', () => {
    setCountryCookies();

    if (!getCookie('_age_checked')) {
      body.classList.add('overflow-hidden');
      ageModal.classList.remove('modal-hidden');
      ageModal.classList.add('modal-visible');
    }

    document.querySelector('#accept_age').addEventListener('click', (event) => {
      body.classList.remove('overflow-hidden');
      ageModal.classList.remove('modal-visible');
      ageModal.classList.add('modal-hidden');

      setCookie('_age_checked', '1', { secure: true, 'max-age': 60 * 60 * 24 * 365 });
    });

    document.querySelector('#reject_age').addEventListener('click', (event) => {
      window.location.href = 'https://www.google.com';
    });

    document.querySelector('#dismiss_CA').addEventListener('click', (event) => {
      body.classList.remove('overflow-hidden');
      countryModalCA.classList.remove('modal-visible');
      countryModalCA.classList.add('modal-hidden');

      setCookie('_country_checked', '1', { secure: true, 'max-age': 60 * 60 * 24 * 365 });
    });

    document.querySelector('#dismiss_UK').addEventListener('click', (event) => {
      body.classList.remove('overflow-hidden');
      countryModalUK.classList.remove('modal-visible');
      countryModalUK.classList.add('modal-hidden');

      setCookie('_country_checked', '1', { secure: true, 'max-age': 60 * 60 * 24 * 365 });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucy-reviews"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    // Set testimonial letters
    const testimonialLetters = document.querySelectorAll('.testimonial-letter');
    testimonialLetters.forEach((letter) => {
      const authorName = letter.getAttribute('data-author');
      if (authorName && authorName.length > 0) {
        letter.textContent = authorName.charAt(0).toUpperCase();
      }
    });

    const swiper = new Swiper('.swiper-reviews', {
      direction: 'horizontal',
      initialSlide: 3,
      centeredSlides: true,
      loop: false,
      slidesPerView: 1.2,
      spaceBetween: 20,
      speed: 500,
      breakpoints: {
        990: {
          slidesPerView: 3.5,
          spaceBetween: 20,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lucy-testimonials"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.swiper-testimonials', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1,
    spaceBetween: 0,
    breakpoints: {
      990: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["made-with-the-best"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE_MQ = '(max-width: 989px)';

    function normalizeFlavor(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');
    }

    function findFlavorAssets(flavors, flavor) {
      if (!flavors || !flavor) return null;
      if (flavors[flavor] && (flavors[flavor].can || flavors[flavor].pouch)) {
        return { key: flavor, assets: flavors[flavor] };
      }

      var needle = normalizeFlavor(flavor);
      var keys = Object.keys(flavors);
      for (var i = 0; i < keys.length; i++) {
        var assets = flavors[keys[i]];
        if (normalizeFlavor(keys[i]) === needle && assets && (assets.can || assets.pouch)) {
          return { key: keys[i], assets: assets };
        }
      }
      return null;
    }

    function flavorFromVariantId(id) {
      if (!id) return null;
      var map = window.LucyFlavorByVariant || {};
      return map[String(id)] || null;
    }

    function isMobile() {
      return window.matchMedia(MOBILE_MQ).matches;
    }

    function stageIsActive(img) {
      var stage = img.closest('.made-with-the-best__stage');
      if (!stage) return false;
      return isMobile()
        ? stage.classList.contains('made-with-the-best__stage--mobile')
        : stage.classList.contains('made-with-the-best__stage--desktop');
    }

    function activateSrc(img) {
      var src = img.getAttribute('data-src');
      if (!src || img.getAttribute('src') === src) return;
      var srcset = img.getAttribute('data-srcset');
      var sizes = img.getAttribute('data-sizes');
      if (srcset) img.setAttribute('srcset', srcset);
      if (sizes) img.setAttribute('sizes', sizes);
      img.setAttribute('src', src);
    }

    function MadeWithTheBest(section) {
      this.section = section;
      this.dataEl = document.getElementById('MadeWithTheBestData-' + section.dataset.sectionId);
      if (!this.dataEl) return;

      try {
        this.data = JSON.parse(this.dataEl.textContent);
      } catch (e) {
        return;
      }

      this.currentFlavor = this.data.selectedFlavor || '';
      this.canEls = section.querySelectorAll('[data-mwtb-can], [data-mwtb-can-mobile]');
      this.pouchEls = section.querySelectorAll('[data-mwtb-pouch], [data-mwtb-pouch-mobile]');
      this.canGhost = section.querySelector('[data-mwtb-can-ghost]');
      this.pouchGhost = section.querySelector('[data-mwtb-pouch-ghost]');
      this.mobilePlaceholder = section.querySelector('.made-with-the-best__placeholder--mobile');
      this.hydrated = false;
      this.track = section.querySelector('[data-mwtb-track]');
      this.properties = section.querySelectorAll('.made-with-the-best__property');
      this.steps = parseInt(section.getAttribute('data-mwtb-steps'), 10) || this.properties.length;
      this.currentStep = -1;
      this.complete = false;
      this.replaceMode = null;
      this.ticking = false;
      this.motionMq = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.syncFromUrl = this.syncFromUrl.bind(this);
      this.onFlavorChange = this.onFlavorChange.bind(this);
      this.onFlavorInput = this.onFlavorInput.bind(this);
      this.hydrateVisible = this.hydrateVisible.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onPinChange = this.onPinChange.bind(this);

      document.addEventListener('lucy:flavorchange', this.onFlavorChange);
      document.addEventListener('change', this.onFlavorInput);
      window.addEventListener('popstate', this.syncFromUrl);
      window.addEventListener('mwtb:urlchange', this.syncFromUrl);
      window.matchMedia(MOBILE_MQ).addEventListener('change', this.hydrateVisible);
      window.matchMedia(MOBILE_MQ).addEventListener('change', this.onPinChange);
      this.motionMq.addEventListener('change', this.onPinChange);

      this.syncFromUrl();
      this.observe();
      this.bindPin();
    }

    MadeWithTheBest.prototype.shouldPin = function () {
      if (this.steps < 1 || !this.track) return false;
      if (this.motionMq.matches) return false;
      if (window.Shopify && Shopify.designMode) return false;
      return true;
    };

    MadeWithTheBest.prototype.bindPin = function () {
      this.onPinChange();
    };

    MadeWithTheBest.prototype.onPinChange = function () {
      if (!this.section.isConnected) {
        this.unbindPin();
        return;
      }

      if (!this.shouldPin()) {
        this.section.classList.add('is-static');
        if (this.track) this.track.style.height = '';
        this.setStep(this.steps);
        this.unbindPin();
        return;
      }

      this.section.classList.remove('is-static');
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.updateStep();
    };

    MadeWithTheBest.prototype.unbindPin = function () {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    };

    MadeWithTheBest.prototype.onScroll = function () {
      if (this.ticking) return;
      this.ticking = true;
      var self = this;
      requestAnimationFrame(function () {
        self.ticking = false;
        self.updateStep();
      });
    };

    MadeWithTheBest.prototype.endPin = function () {
      var rect = this.track.getBoundingClientRect();
      var used = Math.max(window.innerHeight, -rect.top + window.innerHeight);
      this.track.style.height = used + 'px';
    };

    MadeWithTheBest.prototype.updateStep = function () {
      if (!this.section.isConnected) {
        this.unbindPin();
        return;
      }
      if (!this.shouldPin()) {
        this.onPinChange();
        return;
      }
      if (this.complete) {
        this.setStep(this.steps);
        return;
      }

      var rect = this.track.getBoundingClientRect();
      var range = this.track.offsetHeight - window.innerHeight;
      var progress = range <= 0 ? 1 : Math.min(1, Math.max(0, -rect.top / range));
      var step = Math.min(this.steps, Math.floor(progress * (this.steps + 1)));
      var held = this.currentStep < 0 ? 0 : this.currentStep;
      step = Math.max(held, step);

      if (step >= this.steps) {
        this.complete = true;
        this.section.classList.add('is-complete');
        this.setStep(this.steps);
        this.endPin();
        return;
      }

      this.setStep(step);
    };

    MadeWithTheBest.prototype.setStep = function (step) {
      var replace = isMobile();
      if (step === this.currentStep && this.replaceMode === replace) return;
      this.currentStep = step;
      this.replaceMode = replace;

      this.properties.forEach(function (el, index) {
        var visible = replace ? index === step - 1 : index < step;
        el.classList.toggle('is-visible', visible);
        el.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });
    };

    MadeWithTheBest.prototype.observe = function () {
      var self = this;
      var idle =
        window.requestIdleCallback ||
        function (cb) {
          return setTimeout(cb, 1);
        };

      function onIdleHydrate() {
        idle(self.hydrateVisible, { timeout: 3000 });
      }

      if (document.readyState === 'complete') {
        onIdleHydrate();
      } else {
        window.addEventListener('load', onIdleHydrate, { once: true });
      }

      if (!('IntersectionObserver' in window)) {
        this.section.classList.add('is-inview');
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          if (
            !entries.some(function (entry) {
              return entry.isIntersecting;
            })
          )
            return;
          self.section.classList.add('is-inview');
          self.hydrateVisible();
          io.disconnect();
        },
        { rootMargin: '200px 0px' }
      );
      io.observe(this.section);
    };

    MadeWithTheBest.prototype.hydrateVisible = function () {
      this.hydrated = true;
      this.pouchEls.forEach(function (img) {
        if (stageIsActive(img)) activateSrc(img);
      });
      this.canEls.forEach(function (img) {
        if (stageIsActive(img)) activateSrc(img);
      });
    };

    MadeWithTheBest.prototype.onFlavorInput = function (event) {
      var input = event.target;
      if (!input || input.type !== 'radio' || !input.value) return;
      if (normalizeFlavor(input.name) !== 'flavor') return;
      this.setFlavor(input.value);
    };

    MadeWithTheBest.prototype.onFlavorChange = function (event) {
      var flavor = event && event.detail && event.detail.flavor;
      if (!flavor) return;
      this.setFlavor(flavor);
    };

    MadeWithTheBest.prototype.syncFromUrl = function () {
      var id = new URLSearchParams(window.location.search).get('variant');
      var flavor = flavorFromVariantId(id);
      if (flavor) this.setFlavor(flavor);
    };

    MadeWithTheBest.prototype.setFlavor = function (flavor) {
      if (!flavor || normalizeFlavor(flavor) === normalizeFlavor(this.currentFlavor)) return;

      var match = findFlavorAssets(this.data.flavors, flavor);
      if (!match) return;

      var assets = match.assets;
      this.currentFlavor = match.key;
      this.section.dataset.selectedFlavor = match.key;
      this.section.classList.add('is-swapping');

      var self = this;
      this.pouchEls.forEach(function (img) {
        self.applyImage(img, assets.pouch, match.key + ' pouch');
      });
      this.canEls.forEach(function (img) {
        self.applyImage(img, assets.can, match.key + ' can');
      });

      if (this.pouchGhost) this.pouchGhost.hidden = Boolean(assets.pouch);
      if (this.canGhost) this.canGhost.hidden = Boolean(assets.can);
      if (this.mobilePlaceholder) this.mobilePlaceholder.hidden = Boolean(assets.can || assets.pouch);

      window.setTimeout(function () {
        self.section.classList.remove('is-swapping');
      }, 180);
    };

    MadeWithTheBest.prototype.applyImage = function (img, src, alt) {
      if (!img) return;
      if (!src) {
        img.hidden = true;
        img.removeAttribute('src');
        img.removeAttribute('srcset');
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
        return;
      }
      img.hidden = false;
      img.setAttribute('data-src', src);
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.alt = alt;
      if (this.hydrated && stageIsActive(img)) {
        img.src = src;
      } else {
        img.removeAttribute('src');
      }
    };

    function initMadeWithTheBest() {
      document.querySelectorAll('.made-with-the-best[data-section-id]').forEach(function (section) {
        if (section.dataset.mwtbReady) return;
        section.dataset.mwtbReady = 'true';
        section.__mwtb = new MadeWithTheBest(section);
      });
    }

    if (!window.__mwtbHistoryPatched) {
      window.__mwtbHistoryPatched = true;
      ['pushState', 'replaceState'].forEach(function (method) {
        var original = history[method];
        history[method] = function () {
          var result = original.apply(this, arguments);
          window.dispatchEvent(new Event('mwtb:urlchange'));
          return result;
        };
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMadeWithTheBest);
    } else {
      initMadeWithTheBest();
    }

    document.addEventListener('shopify:section:load', initMadeWithTheBest);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  function getCart() {
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((data) => {
        // iterateSellingPlans(data);
        buildCartFooter(data);
      })
      .catch((error) => {
        //handle error
        console.log(error);
      });
  }

  getCart();

  document.addEventListener('update-main-footer', (e) => {
    buildCartFooter(e.detail.parsedState);
  });

  function iterateSellingPlans(data) {
    data.items.map((item) => {
      console.log(item);
      console.log(item.title + ' ' + (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id));
    });
  }

  function buildCartFooter(data) {
    if (data.item_count == 0) return;

    const CPP = new CartPackageProtection();
    const CA = new CartAddons();
    CPP.buildPackageProtectionWidget(data);
    CA.buildCartAddonsWidget(data);
  }

  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  class CartPackageProtection extends HTMLElement {
    constructor() {
      super();
    }

    buildPackageProtectionWidget(data) {
      const PACKAGE_PROTECTION_VID = 41435314159802;
      const SELLING_PLAN_ID = 711590074;
      const checkbox = document.getElementById('checkbox-package-protection');

      const cartHasAProductSubscription = data.items.some(
        (cart_item) => cart_item.id !== PACKAGE_PROTECTION_VID && 'selling_plan_allocation' in cart_item
      );
      const cartHasPackageProtection = data.items.some((cart_item) => cart_item.id == PACKAGE_PROTECTION_VID);
      const cartHasPackageProtectionSubscription = data.items.some(
        (cart_item) => cart_item.id == PACKAGE_PROTECTION_VID && 'selling_plan_allocation' in cart_item
      );
      const cartHasOnlyPackageProtection = data.items.every((cart_item) => cart_item.id == PACKAGE_PROTECTION_VID);
      const body = cartHasAProductSubscription
        ? { id: PACKAGE_PROTECTION_VID, quantity: 1, selling_plan: SELLING_PLAN_ID }
        : { id: PACKAGE_PROTECTION_VID, quantity: 1 };

      // Customer adds or removes package protection
      checkbox.addEventListener('click', function () {
        document.querySelector('.totals__subtotal-value').classList.add('xhidden');
        document.querySelector('#subtotal__spinner').classList.remove('hidden');

        if (checkbox.checked) {
          fetch(`${routes.cart_add_url}`, {
            body: JSON.stringify(body),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            method: 'POST',
          }).then((response) => {
            fetch(`${routes.cart_url}.js`)
              .then((response) => response.json())
              .then((data) => {
                const { original_total_price: new_price } = data;
                document.querySelector('.totals__subtotal-value').innerText = `$${new_price / 100} USD`;
                document.querySelector('.totals__subtotal-value').classList.remove('xhidden');
                document.querySelector('#subtotal__spinner').classList.add('hidden');
                document.getElementById('icon-unlock').classList.add('xhidden');
                document.getElementById('icon-unlock').classList.remove('xblock');
                document.getElementById('icon-lock').classList.remove('xhidden');
                document.getElementById('icon-lock').classList.add('xblock');
              })
              .catch((error) => {
                //handle error
                console.log(error);
              });
          });
        } else {
          fetch(`${routes.cart_update_url}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              updates: {
                41435314159802: 0,
              },
            }),
          }).then((response) => {
            fetch(`${routes.cart_url}.js`)
              .then((response) => response.json())
              .then((data) => {
                const { original_total_price: new_price } = data;
                document.querySelector('.totals__subtotal-value').innerText = `$${new_price / 100} USD`;
                document.querySelector('.totals__subtotal-value').classList.remove('xhidden');
                document.querySelector('#subtotal__spinner').classList.add('hidden');
                document.getElementById('icon-unlock').classList.add('xblock');
                document.getElementById('icon-unlock').classList.remove('xhidden');
                document.getElementById('icon-lock').classList.remove('xblock');
                document.getElementById('icon-lock').classList.add('xhidden');
              })
              .catch((error) => {
                //handle error
                console.log(error);
              });
          });
        }
      });

      // Start with package protection
      if (cartHasPackageProtection) {
        const line_item = data.items.findIndex((cart_item) => cart_item.id === PACKAGE_PROTECTION_VID) + 1;
        checkbox.checked = true;

        if (cartHasAProductSubscription && !cartHasPackageProtectionSubscription) {
          this.swapPackageProtection({
            line: line_item,
            quantity: 1,
            selling_plan: SELLING_PLAN_ID,
          });
        } else if (!cartHasAProductSubscription && cartHasPackageProtectionSubscription) {
          this.swapPackageProtection({
            line: line_item,
            quantity: 1,
            selling_plan: null,
          });
        }
      } else {
        checkbox.checked = false;
        document.getElementById('icon-unlock').classList.add('xblock');
        document.getElementById('icon-unlock').classList.remove('xhidden');
        document.getElementById('icon-lock').classList.remove('xblock');
        document.getElementById('icon-lock').classList.add('xhidden');
      }

      // Disable checkout button and clear cart if only has a package protection
      if (cartHasOnlyPackageProtection) {
        document.querySelector('#checkout').disabled = true;
        this.clearCart();
      }

      // if(!sessionStorage.getItem('packageProtectionAddedFirstTime') && !cartHasPackageProtection) {
      //   sessionStorage.setItem('packageProtectionAddedFirstTime', true);
      //   this.addPackageProtection(body);
      // }
    }

    clearCart() {
      fetch('/cart/clear', {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        method: 'POST',
      }).finally((e) => {
        window.location.reload();
      });
    }

    swapPackageProtection(_body) {
      fetch('/cart/change.js', {
        body: JSON.stringify(_body),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        method: 'POST',
      }).finally((e) => {
        window.location.reload();
      });
    }
  }

  class CartAddons extends HTMLElement {
    constructor() {
      super();
    }

    checkStrengthValue(array, values) {
      for (let item of array) {
        for (let option of item.options_with_values) {
          if (option.name === 'Strength' && values.includes(option.value)) {
            return true;
          }
        }
      }
      return false;
    }

    containsLozengeHandle(products) {
      return products.some((product) => {
        return product.handle === 'lozenge' || product.handle === 'lozenge-variety';
      });
    }

    containsSaleHandle(products) {
      return products.some((product) => product.handle === 'sale');
    }

    onlyContainsSaleHandle(products) {
      return products.every((product) => product.handle === 'sale');
    }

    getProductHandles(products) {
      return products.map((product) => product.variant_options[0] + ' ' + product.product_title);
    }

    buildCartAddonsWidget(data) {
      const businessRules = {
        '2mg Gum': ['LG9X2MGMTUS', 'LB6X4MGMTUS'],
        '4mg Gum': ['LG9X4MGMGUS', 'LG9X4MGV2US'],
        '6mg Gum': ['LB6X8MGESUS', 'LB6X4MGMTUS'],
        '4mg Breakers': ['LG9X4MGBCUS', 'LG9X4MGV2US'],
        '8mg Breakers': ['LB6X8MGESUS'],
        '4mg Pouches': ['LG9X4MGBCUS', 'LG9X4MGV2US'],
        '8mg Pouches': ['LB6X8MGESUS'],
        '12mg Pouches': ['LB6X8MGESUS'],
        '4mg Lozenges': ['LG9X4MGBCUS'],
      };

      const cart_items = data.items;
      const cartHasSaleItem = this.containsSaleHandle(cart_items);
      const productHandles = this.getProductHandles(cart_items);
      const cartOnlyHasSaleItem = this.onlyContainsSaleHandle(cart_items);
      const cartAddons = document.getElementsByClassName('cart-add-ons__item');

      // Hide items every time
      for (let i = 0; i < cartAddons.length; i++) {
        cartAddons[i].classList.add('xhidden');
      }

      // Hide the add-ons if cart has sale item
      if (cartHasSaleItem) {
        document.getElementById('cart-add-ons').classList.add('xhidden');
      }

      const offeringSKUs = businessRules[productHandles[0]];
      if (offeringSKUs) {
        offeringSKUs.forEach((sku) => {
          const element = document.getElementById(sku);
          if (element) {
            element.classList.remove('xhidden');
          }
        });
      }

      if (cartOnlyHasSaleItem) {
        document.getElementById('checkout').classList.remove('xbg-teal');
        document.getElementById('checkout').classList.add('xbg-gray-500');
        document.getElementById('checkout').disabled = true;
      }
    }
  }

  class CartPackagingNote extends HTMLElement {
    constructor() {
      super();
    }
  }

  customElements.define('cart-package-protection', CartPackageProtection);
  customElements.define('cart-note', CartNote);
  customElements.define('cart-add-ons', CartAddons);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  const selling_plan_gum = 711655610;
  const selling_plan_breakers = 711622842;
  const selling_plan_pouches = 711688378;
  const selling_plan_lozenge = 1302921402;

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.button-subscribe-save').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        this.innerText = 'Upgrading...';
        this.classList.add('xanimate-pulse');

        const key = this.dataset.key;
        const productType = this.dataset.productType;
        let selling_plan;

        switch (productType.toLowerCase()) {
          case 'gum':
            selling_plan = selling_plan_gum;
            break;
          case 'pouches':
            selling_plan = selling_plan_pouches;
            break;
          case 'breakers':
            selling_plan = selling_plan_breakers;
            break;
          case 'lozenge':
            selling_plan = selling_plan_lozenge;
            break;
          default:
            break;
        }

        const body = { id: key, selling_plan: selling_plan };

        fetch(`${routes.cart_change_url}`, {
          body: JSON.stringify(body),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          method: 'POST',
        }).then((response) => {
          fetch(`${routes.cart_url}.js`)
            .then((response) => response.json())
            .then((data) => {
              window.location.reload();
            })
            .catch((error) => {
              //handle error
              console.log(error);
            });
        });
      });
    });

    document.querySelectorAll('.select-change-plan').forEach(function (select) {
      select.addEventListener('change', function (event) {
        event.preventDefault();

        const selectedOption = select.options[select.selectedIndex];
        selectedOption.text = 'Downgrading...';

        const key = this.dataset.key;
        const body = { id: key, selling_plan: null };

        fetch(`${routes.cart_change_url}`, {
          body: JSON.stringify(body),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          method: 'POST',
        }).then((response) => {
          fetch(`${routes.cart_url}.js`)
            .then((response) => response.json())
            .then((data) => {
              window.location.reload();
            })
            .catch((error) => {
              //handle error
              console.log(error);
            });
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    window.addEventListener('DOMContentLoaded', () => {
      console.log('DOMContentLoaded');

      // Cache frequently used selectors for performance
      const domCache = {
        get productInfoContainer() {
          return (
            this._productInfoContainer ||
            (this._productInfoContainer = document.querySelector('.product__info-container'))
          );
        },
        get addToCartButton() {
          return document.querySelector('#AddToCartButtons .product-form__submit > div:first-child');
        },
        get mobilePrice() {
          return document.getElementById('mobile-price');
        },
        get desktopPrice() {
          return document.getElementById('desktop-price');
        },
        get quantityInput() {
          return document.querySelector('[data-actual-quantity-input]');
        },
        // Dynamic selectors that change frequently
        getActiveRadio() {
          return document.querySelector('.rc-radio--active');
        },
        getOneTimeRadio() {
          return document.querySelector('.rc-widget .onetime-radio, .onetime-radio');
        },
        getSubscriptionRadio() {
          return document.querySelector('.rc-widget .subscription-radio, .subscription-radio');
        },
      };

      setTimeout(() => {
        let clone = document.getElementsByClassName('junip-product-summary')[0].cloneNode(true);
        clone.classList.add('junip-summary-clone');
        document.getElementById('junip-summary-clone').appendChild(clone);
      }, 1);

      // PDP: Normalize Junip review count text using data attributes
      function updatePDPJunipReviewCounts() {
        const summaries = document.querySelectorAll('.junip-product-summary');
        summaries.forEach((summary) => {
          const countEl = summary.querySelector('.junip-product-summary-review-count');
          if (!countEl) return;

          const avgStr = summary.getAttribute('data-product-rating-average');
          const cntStr = summary.getAttribute('data-product-rating-count');
          if (!avgStr || !cntStr) return;

          const avg = parseFloat(avgStr);
          const count = parseInt(cntStr, 10);
          if (Number.isNaN(avg) || Number.isNaN(count)) return;

          const ratingText = avg.toFixed(1);
          // const reviewsText = `${count.toLocaleString()} reviews`;
          // const newHTML = `${ratingText} based from <span class="junip-review-count-text">${reviewsText}</span>`;
          const newHTML = `(${count.toLocaleString()})`;

          if (countEl.innerHTML !== newHTML) {
            countEl.innerHTML = newHTML;
          }
          // Mark as ready to reveal (CSS hides until this class is present)
          countEl.classList.add('junip-ready');
        });
      }

      // Initial attempts (covers cloned header summary and late Junip init)
      setTimeout(updatePDPJunipReviewCounts, 50);
      setTimeout(updatePDPJunipReviewCounts, 200);
      setTimeout(updatePDPJunipReviewCounts, 600);

      // Observe DOM for Junip injections/changes
      (function setupPDPJunipReviewObserver() {
        const mo = new MutationObserver((mutations) => {
          let shouldRun = false;
          for (const m of mutations) {
            m.addedNodes &&
              m.addedNodes.forEach((node) => {
                if (
                  node.nodeType === 1 &&
                  (node.classList?.contains('junip-product-summary') ||
                    node.classList?.contains('junip-product-summary-review-count') ||
                    node.querySelector?.('.junip-product-summary, .junip-product-summary-review-count'))
                ) {
                  shouldRun = true;
                }
              });
            if (
              m.type === 'attributes' &&
              m.target &&
              m.target.classList &&
              (m.target.classList.contains('junip-product-summary') ||
                m.target.classList.contains('junip-product-summary-review-count'))
            ) {
              shouldRun = true;
            }
          }
          if (shouldRun) setTimeout(updatePDPJunipReviewCounts, 25);
        });
        mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        window.addEventListener('beforeunload', () => mo.disconnect());
      })();

      // Guard to prevent infinite loops in main price updates
      let isUpdatingMainPrice = false;

      function getPriceTextFromRadio(radio) {
        if (!radio) return '';

        const priceLabel = radio.querySelector('.price-label');
        if (!priceLabel) return '';

        if (priceLabel.dataset.originalPrice) {
          return priceLabel.dataset.originalPrice;
        }

        const regularPriceElement = radio.querySelector('span.price__regular');
        const priceText = regularPriceElement
          ? regularPriceElement.textContent.trim()
          : priceLabel.childNodes[0]?.textContent?.trim() || priceLabel.textContent.trim();

        return priceText.replace(/\s+/g, ' ').trim();
      }

      function getDisplayedPriceTextFromRadio(radio) {
        if (!radio) return '';

        const priceLabel = radio.querySelector('.price-label');
        if (!priceLabel) return '';

        const regularPriceElement = radio.querySelector('span.price__regular');
        const priceText = regularPriceElement
          ? regularPriceElement.textContent.trim()
          : priceLabel.childNodes[0]?.textContent?.trim() || priceLabel.textContent.trim();

        return priceText.replace(/\s+/g, ' ').trim();
      }

      function parseMoneyValue(value) {
        const numericValue = parseFloat((value || '').replace(/[^0-9.]/g, ''));
        return Number.isNaN(numericValue) ? null : numericValue;
      }

      function formatMoneyValue(value) {
        if (value === null || Number.isNaN(value)) return '';
        return `$${value.toFixed(2)}`;
      }

      function roundMoney(value) {
        return Math.round((value + 0.000001) * 100) / 100;
      }

      function getRadioOrderType(radio) {
        return radio?.classList.contains('subscription-radio') ? 'subscription' : 'onetime';
      }

      function getPackPricingContext() {
        const packMultiplierInput = document.getElementById('pack-multiplier-input');
        const activePackButton = document.querySelector('[data-pack-option].is-active');
        const packMultiplier = parseInt(
          activePackButton?.dataset.packMultiplier || packMultiplierInput?.value || '1',
          10
        );
        const hasPackSelector = !!activePackButton;
        const isBulkPack = hasPackSelector && packMultiplier > 1;
        const isBreakers = window.location.pathname.includes('breaker');
        const discountRate = isBreakers ? 0.15 : 0.1;
        const bulkDiscountMultiplier = 1 - discountRate;

        return { packMultiplier, isBulkPack, discountRate, bulkDiscountMultiplier, hasPackSelector, isBreakers };
      }

      function getBasePackUnitCount() {
        return typeof getSelectedPackSize === 'function' ? getSelectedPackSize(5) : 5;
      }

      function getCheckoutBulkTotal(basePackPrice, multiplier, orderType = 'onetime') {
        const { discountRate, bulkDiscountMultiplier, isBreakers } = getPackPricingContext();
        const safeMultiplier = Math.max(multiplier, 1);

        if (isBreakers && orderType === 'subscription') {
          const basePackUnits = getBasePackUnitCount();
          const roundedPerUnit = roundMoney((basePackPrice * bulkDiscountMultiplier) / basePackUnits);
          return roundMoney(roundedPerUnit * basePackUnits * safeMultiplier);
        }

        if (isBreakers) {
          return roundMoney(roundMoney(basePackPrice * bulkDiscountMultiplier) * safeMultiplier);
        }

        const roundedDiscount = roundMoney(basePackPrice * discountRate);
        return roundMoney(roundMoney(basePackPrice - roundedDiscount) * safeMultiplier);
      }

      function getPackAdjustedPriceText(priceText, orderType = 'onetime') {
        if (!priceText) return '';

        const normalizedPriceText = priceText.replace(/\s+/g, ' ').trim();
        const price = parseMoneyValue(normalizedPriceText);

        if (price === null) return normalizedPriceText;

        const { packMultiplier, isBulkPack } = getPackPricingContext();
        const adjustedPrice = isBulkPack ? getCheckoutBulkTotal(price, packMultiplier, orderType) : price;

        return formatMoneyValue(adjustedPrice);
      }

      function getATCPriceFromTitle(quantity, fallbackPrice) {
        const titlePriceContainer = domCache.desktopPrice || domCache.mobilePrice;
        const otpPrice = titlePriceContainer?.querySelector('[data-otp-price]');
        const subscriptionRadio = domCache.getSubscriptionRadio();
        const activePriceElement = titlePriceContainer?.querySelector(
          '.product-title-price--active:not(.product-title-price--hidden)'
        );
        const comparePriceElement = titlePriceContainer?.querySelector(
          '.product-title-price--inactive:not(.product-title-price--hidden)'
        );
        const parsedActivePrice = parseMoneyValue(activePriceElement?.textContent);
        const activeUnitPrice = parsedActivePrice ?? fallbackPrice;
        let compareUnitPrice = parseMoneyValue(comparePriceElement?.textContent);
        const { packMultiplier, isBulkPack, hasPackSelector } = getPackPricingContext();
        const isBasePackBulkQuantity = hasPackSelector && !isBulkPack && quantity >= 4;
        const orderType = subscriptionRadio?.classList.contains('rc-radio--active') ? 'subscription' : 'onetime';

        let discountedTotal = activeUnitPrice * quantity;

        if (isBulkPack && parsedActivePrice === null) {
          compareUnitPrice = compareUnitPrice ?? roundMoney(fallbackPrice * Math.max(packMultiplier, 1));
          discountedTotal = getCheckoutBulkTotal(fallbackPrice, packMultiplier, orderType) * quantity;
        } else if (isBasePackBulkQuantity) {
          compareUnitPrice = compareUnitPrice ?? parseMoneyValue(otpPrice?.textContent) ?? activeUnitPrice;
          discountedTotal = getCheckoutBulkTotal(activeUnitPrice, quantity, orderType);
        }

        const regularTotal = compareUnitPrice !== null ? compareUnitPrice * quantity : discountedTotal;
        const hasComparePrice = regularTotal > discountedTotal;

        return {
          discountedTotal: roundMoney(discountedTotal),
          regularTotal: roundMoney(regularTotal),
          hasComparePrice,
        };
      }

      function updateProductTitlePrices() {
        const oneTimeRadio = domCache.getOneTimeRadio();
        const subscriptionRadio = domCache.getSubscriptionRadio();
        const oneTimeDisplayedPriceText = getDisplayedPriceTextFromRadio(oneTimeRadio);
        const subscriptionDisplayedPriceText = getDisplayedPriceTextFromRadio(subscriptionRadio);
        const oneTimeBasePriceText = getPriceTextFromRadio(oneTimeRadio);
        const subscriptionBasePriceText = getPriceTextFromRadio(subscriptionRadio);
        const { packMultiplier, isBulkPack } = getPackPricingContext();

        const isSubscriptionActive = !!subscriptionRadio?.classList.contains('rc-radio--active');

        let strikePriceText = '';
        let activePriceText = '';
        let shouldShowComparisonPrice = false;

        if (!isBulkPack && isSubscriptionActive) {
          // 1) Normal size + Subscribe & Save = OTP strike + SS active
          strikePriceText = oneTimeBasePriceText || oneTimeDisplayedPriceText;
          activePriceText = subscriptionDisplayedPriceText || subscriptionBasePriceText;
          shouldShowComparisonPrice = !!activePriceText;
        } else if (!isBulkPack && !isSubscriptionActive) {
          // 2) Normal size + OTP = OTP only
          strikePriceText = oneTimeDisplayedPriceText || oneTimeBasePriceText;
          shouldShowComparisonPrice = false;
        } else if (isBulkPack && isSubscriptionActive) {
          // 3) Bigger bundle + Subscribe & Save = OTP bundled strike + bundled SS active
          const oneTimeBasePriceValue = parseMoneyValue(oneTimeBasePriceText || oneTimeDisplayedPriceText);
          strikePriceText =
            oneTimeBasePriceValue !== null
              ? formatMoneyValue(roundMoney(oneTimeBasePriceValue * Math.max(packMultiplier, 1)))
              : oneTimeBasePriceText || oneTimeDisplayedPriceText;
          activePriceText = getPackAdjustedPriceText(
            subscriptionBasePriceText || subscriptionDisplayedPriceText,
            'subscription'
          );
          shouldShowComparisonPrice = !!activePriceText;
        } else {
          // 4) Bigger bundle + OTP = pre-discount OTP bundle strike + discounted OTP bundle active
          const oneTimeBasePriceValue = parseMoneyValue(oneTimeBasePriceText || oneTimeDisplayedPriceText);
          strikePriceText =
            oneTimeBasePriceValue !== null
              ? formatMoneyValue(roundMoney(oneTimeBasePriceValue * Math.max(packMultiplier, 1)))
              : oneTimeBasePriceText || oneTimeDisplayedPriceText;
          activePriceText = getPackAdjustedPriceText(oneTimeBasePriceText || oneTimeDisplayedPriceText, 'onetime');
          shouldShowComparisonPrice = !!activePriceText;
        }

        [domCache.mobilePrice, domCache.desktopPrice].forEach((container) => {
          if (!container) return;

          const otpPrice = container.querySelector('[data-otp-price]');
          const subscriptionPrice = container.querySelector('[data-subscription-price]');
          if (!otpPrice || !subscriptionPrice) return;

          otpPrice.textContent = strikePriceText;
          subscriptionPrice.textContent = activePriceText;

          otpPrice.classList.toggle('product-title-price--active', !shouldShowComparisonPrice);
          otpPrice.classList.toggle('product-title-price--inactive', shouldShowComparisonPrice);
          subscriptionPrice.classList.toggle('product-title-price--active', shouldShowComparisonPrice);
          subscriptionPrice.classList.toggle('product-title-price--inactive', false);
          subscriptionPrice.classList.toggle('product-title-price--hidden', !shouldShowComparisonPrice);
        });
      }

      // Function to update prices from active rc-radio element
      function updatePricesFromActiveRadio() {
        if (isUpdatingMainPrice) {
          console.log('Already updating main prices, skipping to prevent loop');
          return;
        }

        isUpdatingMainPrice = true;
        console.log('updatePricesFromActiveRadio called');

        try {
          const activeRadio = domCache.getActiveRadio();
          console.log('Active radio found:', !!activeRadio);

          if (activeRadio) {
            const priceLabel = activeRadio.querySelector('.price-label');
            console.log('Price label found:', !!priceLabel);

            if (priceLabel) {
              // Extract price text (remove any child elements like price-per-unit)
              const priceText = priceLabel.childNodes[0]?.textContent?.trim() || priceLabel.textContent.trim();
              console.log('Extracted price text:', priceText);

              updateProductTitlePrices();

              // NEW: Update ATC button with total checkout price
              updateATCButtonPrice(priceText);

              // NEW: Update dynamic per-unit pricing
              updateDynamicPricing();
            }
          } else {
            console.log('No active radio found - skipping price update');
          }
        } catch (error) {
          console.error('Error in updatePricesFromActiveRadio:', error);
        } finally {
          // Reset the guard after a short delay
          setTimeout(() => {
            isUpdatingMainPrice = false;
          }, 10);
        }
      }

      let isInternalWidgetUpdate = false;

      function updateWidgetPriceLabels() {
        const oneTimeRadio = domCache.getOneTimeRadio();
        const subscriptionRadio = domCache.getSubscriptionRadio();

        isInternalWidgetUpdate = true;

        [oneTimeRadio, subscriptionRadio].forEach((radio) => {
          if (!radio) return;
          const priceLabel = radio.querySelector('.price-label');
          if (!priceLabel) return;

          const regularPriceElement = radio.querySelector('span.price__regular');
          const currentText = (
            regularPriceElement
              ? regularPriceElement.textContent.trim()
              : priceLabel.childNodes[0]?.textContent?.trim() || priceLabel.textContent.trim()
          )
            .replace(/\s+/g, ' ')
            .trim();

          const storedAdjusted = priceLabel.dataset.adjustedPrice;

          if (!priceLabel.dataset.originalPrice || (storedAdjusted && currentText !== storedAdjusted)) {
            priceLabel.dataset.originalPrice = currentText;
          }

          const adjustedText = getPackAdjustedPriceText(priceLabel.dataset.originalPrice, getRadioOrderType(radio));
          priceLabel.dataset.adjustedPrice = adjustedText;

          if (regularPriceElement) {
            regularPriceElement.textContent = adjustedText;
          } else {
            const textNode = Array.from(priceLabel.childNodes).find(
              (n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim()
            );
            if (textNode) {
              textNode.textContent = adjustedText;
            } else if (priceLabel.childNodes[0]) {
              priceLabel.childNodes[0].textContent = adjustedText;
            } else {
              priceLabel.textContent = adjustedText;
            }
          }
        });

        setTimeout(() => {
          isInternalWidgetUpdate = false;
        }, 50);
      }

      // Guard to prevent infinite loops in price updates
      let isUpdatingDynamicPricing = false;

      // Function to update dynamic per-unit pricing
      function updateDynamicPricing() {
        if (isUpdatingDynamicPricing) {
          console.log('Already updating dynamic pricing, skipping to prevent loop');
          return;
        }

        isUpdatingDynamicPricing = true;

        try {
          if (window.updateOneTimePricing) {
            window.updateOneTimePricing();
          }
          if (window.updateSubscriptionPricing) {
            window.updateSubscriptionPricing();
          }
        } catch (error) {
          console.error('Error updating dynamic pricing:', error);
        } finally {
          // Reset the guard after a short delay
          setTimeout(() => {
            isUpdatingDynamicPricing = false;
          }, 10);
        }
      }

      window.updateWidgetPriceLabels = updateWidgetPriceLabels;
      window.updateProductTitlePrices = updateProductTitlePrices;
      window.updateDynamicPricing = updateDynamicPricing;

      // NEW: Function to update Add to Cart button with total price
      function updateATCButtonPrice(priceText) {
        console.log('updateATCButtonPrice called with:', priceText);
        const quantityInput = domCache.quantityInput;
        const atcButtonText = domCache.addToCartButton;
        const submitButton = document.querySelector('#AddToCartButtons .product-form__submit');

        console.log('Quantity input found:', !!quantityInput);
        console.log('ATC button text element found:', !!atcButtonText);

        if (quantityInput && atcButtonText && submitButton) {
          const facadeInput = document.querySelector('[data-quantity-facade]');
          const quantity = facadeInput ? parseInt(facadeInput.value) || 1 : parseInt(quantityInput.value) || 1;

          const activeRadio = domCache.getActiveRadio();
          let actualPriceText = priceText;

          if (activeRadio) {
            const regularPriceElement = activeRadio.querySelector('span.price__regular');
            if (regularPriceElement) {
              // Sale price exists, use it for calculation
              actualPriceText = regularPriceElement.textContent.trim();
              console.log('Using sale price for ATC button:', actualPriceText);
            } else if (priceText) {
              actualPriceText = priceText;
              console.log('Using regular price for ATC button:', actualPriceText);
            }
          }

          const priceLabel = activeRadio?.querySelector('.price-label');
          const basePriceText = priceLabel?.dataset.originalPrice || actualPriceText;
          const price = parseMoneyValue(basePriceText);
          const isAvailable = !submitButton.disabled;

          console.log('Quantity:', quantity, 'Price:', price, 'Button available:', isAvailable);

          if (price !== null) {
            const { discountedTotal, regularTotal, hasComparePrice } = getATCPriceFromTitle(quantity, price);
            const totalPrice = discountedTotal.toFixed(2);
            const comparePrice = regularTotal.toFixed(2);
            const newButtonText = hasComparePrice
              ? `Add to Cart - $${totalPrice} $${comparePrice}`
              : `Add to Cart · $${totalPrice}`;

            const needsCompareMarkup = hasComparePrice && !atcButtonText.querySelector('.atc-price-compare');

            // Only update pricing if button is available and text or markup has changed
            if (isAvailable && (atcButtonText.textContent.trim() !== newButtonText || needsCompareMarkup)) {
              console.log('Setting button text to:', newButtonText);

              if (hasComparePrice) {
                const currentPrice = document.createElement('span');
                currentPrice.className = 'atc-price-current';
                currentPrice.textContent = `$${totalPrice}`;

                const compareAtPrice = document.createElement('span');
                compareAtPrice.className = 'atc-price-compare';
                compareAtPrice.textContent = `$${comparePrice}`;

                atcButtonText.replaceChildren('Add to Cart - ', currentPrice, ' ', compareAtPrice);
              } else {
                atcButtonText.textContent = newButtonText;
              }
            } else {
              console.log('Button disabled or text unchanged - skipping update');
            }

            // Update slider price always (regardless of visibility)
            const sliderPrice = document.getElementById('slider-product-price');
            if (sliderPrice) {
              sliderPrice.textContent = `$${totalPrice}`;
            }
          }
        } else {
          console.log('Missing required elements');
        }
      }

      // Initial price update when page loads - try multiple times until successful
      function initialPriceSetup() {
        // console.log('Attempting initial price setup...');
        const activeRadio = domCache.getActiveRadio();

        if (activeRadio) {
          // console.log('RC radio found on initial setup');
          updatePricesFromActiveRadio();
        } else {
          // console.log('RC radio not ready yet, retrying...');
          setTimeout(initialPriceSetup, 200);
        }
      }

      // Start initial setup attempts
      setTimeout(initialPriceSetup, 100);
      setTimeout(initialPriceSetup, 500);
      setTimeout(initialPriceSetup, 1000);

      // Consolidated debounce function to prevent rapid-fire updates
      let priceUpdateTimeout;
      function debouncedPriceUpdate() {
        clearTimeout(priceUpdateTimeout);
        priceUpdateTimeout = setTimeout(() => {
          console.log('Debounced price update starting...');

          // Persistent retry logic for variant changes
          function retryPriceUpdate(attempt = 1, maxAttempts = 8) {
            console.log(`Price update attempt ${attempt}/${maxAttempts}`);

            const activeRadio = domCache.getActiveRadio();
            const submitButton = document.querySelector('#AddToCartButtons .product-form__submit');

            if (activeRadio && submitButton && !submitButton.disabled) {
              console.log('Active radio found and button available, updating pricing');
              updatePricesFromActiveRadio();
              return; // Success, stop retrying
            }

            if (attempt < maxAttempts) {
              const delay = Math.min(150 * attempt, 800); // Longer delays: 150ms, 300ms, 450ms, etc.
              setTimeout(() => retryPriceUpdate(attempt + 1, maxAttempts), delay);
            } else {
              console.log('Max attempts reached, giving up on price update');
            }
          }

          // Start retry sequence
          retryPriceUpdate();
        }, 200); // 200ms debounce delay
      }

      // Single consolidated event listener for better performance
      document.addEventListener(
        'click',
        (e) => {
          // RC radio clicks
          if (e.target.closest('.rc-radio') || e.target.classList.contains('rc-radio')) {
            setTimeout(updatePricesFromActiveRadio, 50);
            return;
          }

          // Product info container clicks
          if (e.target.closest('.product__info-container')) {
            console.log('Product info container clicked:', e.target);
            debouncedPriceUpdate();
            return;
          }

          // Quantity button clicks (+ and - buttons)
          if (e.target.closest('.quantity__button')) {
            setTimeout(() => {
              const activeRadio = domCache.getActiveRadio();
              if (activeRadio) {
                const priceLabel = activeRadio.querySelector('.price-label');
                if (priceLabel) {
                  const priceText = priceLabel.childNodes[0]?.textContent?.trim() || priceLabel.textContent.trim();
                  updateATCButtonPrice(priceText);
                }
              }
            }, 50);
            return;
          }
        },
        { passive: true }
      );

      const priceObserver = new MutationObserver(() => {
        if (isInternalWidgetUpdate) return;
        updateWidgetPriceLabels();
        updatePricesFromActiveRadio();
      });

      // Start observing when rc-widget appears
      const widgetObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.classList && node.classList.contains('rc-widget')) {
              priceObserver.observe(node, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class'],
              });
            }
          });
        });
      });

      widgetObserver.observe(document.body, { childList: true, subtree: true });

      // NEW: Watch for Shopify's "Sold Out" → "Add to Cart" reset and restore pricing
      const buttonTextObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.target.matches('#AddToCartButtons .product-form__submit > div:first-child')) {
            const buttonText = mutation.target.textContent.trim();
            console.log('Button text changed to:', buttonText);

            // If Shopify just reset it to plain "Add to Cart" or "Add to cart", restore our pricing
            if (buttonText === 'Add to Cart' || buttonText === 'Add to cart') {
              console.log('Detected plain "Add to Cart" - restoring pricing...');

              // Use persistent retry for button text restoration
              function retryButtonRestore(attempt = 1, maxAttempts = 5) {
                console.log(`Button restore attempt ${attempt}/${maxAttempts}`);

                const activeRadio = document.querySelector('.rc-radio--active');
                if (activeRadio) {
                  console.log('Active radio found for button restore');
                  updatePricesFromActiveRadio();
                  return;
                }

                if (attempt < maxAttempts) {
                  const delay = 50 * attempt; // 50ms, 100ms, 150ms, etc.
                  setTimeout(() => retryButtonRestore(attempt + 1, maxAttempts), delay);
                } else {
                  console.log('Button restore max attempts reached');
                }
              }

              retryButtonRestore();
            }
          }
        });
      });

      // Start watching the button text for Shopify's resets
      const addToCartButtonText = document.querySelector('#AddToCartButtons .product-form__submit > div:first-child');
      if (addToCartButtonText) {
        buttonTextObserver.observe(addToCartButtonText, {
          childList: true,
          characterData: true,
          subtree: true,
        });
      }

      // Keep quantity change listeners since they might not trigger container click
      // Consolidated input/change event listener
      document.addEventListener(
        'input',
        (e) => {
          // Quantity input changes
          if (e.target.classList.contains('quantity__input')) {
            const activeRadio = domCache.getActiveRadio();
            if (activeRadio) {
              const priceLabel = activeRadio.querySelector('.price-label');
              if (priceLabel) {
                const priceText = priceLabel.childNodes[0]?.textContent?.trim() || priceLabel.textContent.trim();
                updateATCButtonPrice(priceText);
              }
            }
          }
        },
        { passive: true }
      );

      // Consolidated change event listener
      document.addEventListener(
        'change',
        (e) => {
          // Size option changes (important for gum per-unit pricing)
          if (e.target.classList.contains('size-option')) {
            console.log('Size option changed, updating dynamic pricing');
            setTimeout(() => {
              updateDynamicPricing();
            }, 50);
          }
        },
        { passive: true }
      );

      function createList(isOneTime) {
        const productType = window.getCurrentProductType();
        const list = document.createElement('ul');
        const pricePerUnit = document.createElement('div');
        list.classList.add(
          'xflex',
          'xflex-col',
          'xitems-start',
          'xml-[5px]',
          'xtext-[12px]',
          'xw-full',
          'xleading-[1.5]'
        );

        const listElement1 = document.createElement('li');
        const listElement2 = document.createElement('li');

        if (isOneTime) {
        } else {
          listElement1.innerHTML =
            '<div class="xflex xitems-center xnot-italic"><svg class="xmr-[8px]" width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.1818 1.5L4.18182 8.5L1 5.31818" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg> Monthly subscription</div>';
          listElement2.innerHTML =
            '<div class="xflex xitems-center xnot-italic"><svg class="xmr-[8px]" width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.1818 1.5L4.18182 8.5L1 5.31818" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg> No commitment, cancel anytime</div>';

          list.appendChild(listElement1);
          list.appendChild(listElement2);
        }

        return list;
      }

      // Get current pack size from the hidden size option radios
      function getSelectedPackSize(defaultPackSize) {
        const sizeOption = document.querySelector('.size-option:checked');
        if (sizeOption) {
          const sizeValue = sizeOption.getAttribute('data-size-value') || '';
          const sizeMatch = sizeValue.match(/(\d+)/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1], 10);
          }
        }
        return defaultPackSize;
      }

      // Get unit divisor and text based on product type
      function getUnitInfo(productType) {
        switch (productType) {
          case 'breakers':
          case 'breakersf':
          case 'pouches':
          case 'pouchesf':
          case 'tobacco-breakers':
            return { divisor: getSelectedPackSize(5), unitText: 'can' };
          case 'lucy-tobacco-pouches':
          case 'lucy-tobacco-pouchesf':
          case 'non-flavored-pouches':
          case 'non-flavored-pouchesf':
          case 'unflavored-pouches':
          case 'unflavored-pouchesf':
            return { divisor: 5, unitText: 'can' };
          case 'tobacco-gum':
          case 'quit-gum':
            return { divisor: getSelectedPackSize(10), unitText: 'pack' };
          case 'gum':
          case 'gumf':
            const packSize = getSelectedPackSize(9);
            return { divisor: packSize, unitText: 'pack' };
          default:
            return { divisor: 1, unitText: 'unit' };
        }
      }

      // Create dynamic price per unit element
      function createDynamicPricePerUnit(isOneTime) {
        const productType = window.getCurrentProductType();
        const container = document.createElement('div');
        container.classList.add(
          'dynamic-price-per-unit',
          'favorit',
          'xnot-italic',
          'xabsolute',
          'xtop-[20px]',
          'xright-[15px]',
          'xfont-500',
          // 'xflex',
          // 'xflex-col',
          // 'xitems-end',
          // 'xtext-right',
          'xz-10',
          'xtext-inherit'
        );

        // Add a distinctive identifier for debugging
        container.setAttribute('data-pricing-type', isOneTime ? 'onetime' : 'subscription');

        // Create price element (larger, bold)
        const priceElement = document.createElement('span');
        priceElement.classList.add('xtext-[16px]', 'xfont-bold', 'xleading-[1.5]');

        // Create unit element (smaller, normal weight)
        const unitElement = document.createElement('span');
        unitElement.classList.add('xtext-[16px]', 'xfont-bold', 'xleading-[1.5]');

        container.appendChild(priceElement);
        container.appendChild(unitElement);

        const updatePrice = () => {
          const targetRadio = isOneTime ? domCache.getOneTimeRadio() : domCache.getSubscriptionRadio();
          if (!targetRadio) return;

          const priceLabel = targetRadio.querySelector('.price-label');
          if (!priceLabel) return;

          let priceText;
          if (priceLabel.dataset.originalPrice) {
            priceText = priceLabel.dataset.originalPrice;
          } else {
            const regularPriceElement = targetRadio.querySelector('span.price__regular');
            priceText = regularPriceElement
              ? regularPriceElement.textContent.trim()
              : priceLabel.childNodes[0]?.textContent?.trim() || priceLabel.textContent.trim();
          }

          const price = parseFloat(priceText.replace(/[^0-9.]/g, ''));
          if (isNaN(price)) return;

          const activePackButton = document.querySelector('[data-pack-option].is-active');
          const packMultiplier = parseInt(activePackButton?.dataset.packMultiplier || '1', 10);
          const isBulkPack = packMultiplier > 1;
          const isBreakers = window.location.pathname.includes('breaker');
          const bulkDiscount = isBreakers ? 0.85 : 0.9;
          const discountedPrice = isBulkPack ? price * bulkDiscount : price;

          const unitInfo = getUnitInfo(productType);
          const perUnitPrice = (discountedPrice / unitInfo.divisor).toFixed(2);

          const newPriceText = `$${perUnitPrice}`;
          const newUnitText = `/${unitInfo.unitText}`;

          if (priceElement.textContent !== newPriceText) {
            priceElement.textContent = newPriceText;
          }
          if (unitElement.textContent !== newUnitText) {
            unitElement.textContent = newUnitText;
          }
        };

        // Return both the container and update function
        return { container, updatePrice };
      }

      const observer = new MutationObserver(function (mutationRecords) {
        for (const mutation of mutationRecords) {
          if (mutation.addedNodes[0] && mutation.addedNodes[0].className == 'rc-widget') {
            // Add a small delay to ensure DOM is fully rendered
            setTimeout(() => {
              const radioOneTimeButton = domCache.getOneTimeRadio();
              const radioSubscriptionButton = domCache.getSubscriptionRadio();
              const radioOneTimeButtonPriceLabel = radioOneTimeButton?.querySelector('.price-label');
              const radioSubscriptionButtonPriceLabel = radioSubscriptionButton?.querySelector('.price-label');

              if (
                !radioOneTimeButton ||
                !radioSubscriptionButton ||
                !radioOneTimeButtonPriceLabel ||
                !radioSubscriptionButtonPriceLabel
              ) {
                console.error('Required elements not found');
                return;
              }

              // Create elements
              const oneTimeList = createList(true);
              const oneTimePricing = createDynamicPricePerUnit(true);
              const subscriptionList = createList(false);
              const subscriptionPricing = createDynamicPricePerUnit(false);

              console.log('Created pricing containers:', {
                onetime: !!oneTimePricing.container,
                subscription: !!subscriptionPricing.container,
              });

              // Remove any existing elements first - now look for siblings
              const existingOneTimePrice = radioOneTimeButton.querySelector('.dynamic-price-per-unit');
              const existingSubPrice = radioSubscriptionButton.querySelector('.dynamic-price-per-unit');
              if (existingOneTimePrice) existingOneTimePrice.remove();
              if (existingSubPrice) existingSubPrice.remove();

              // Append new elements as siblings, not children of price-label
              radioOneTimeButton.appendChild(oneTimeList);
              radioOneTimeButton.appendChild(oneTimePricing.container);
              radioSubscriptionButton.appendChild(subscriptionList);
              radioSubscriptionButton.appendChild(subscriptionPricing.container);

              // CRITICAL FIX: Make radio button labels positioned relative for absolute children
              radioOneTimeButton.style.position = 'relative';
              radioSubscriptionButton.style.position = 'relative';

              // Apply translateY to price-labels to move them down
              radioOneTimeButtonPriceLabel.style.transform = 'translateY(18px)';
              radioSubscriptionButtonPriceLabel.style.transform = 'translateY(18px)';

              // Store update functions for later use
              window.updateOneTimePricing = oneTimePricing.updatePrice;
              window.updateSubscriptionPricing = subscriptionPricing.updatePrice;

              // Set initial visibility based on active state
              const isOneTimeActive = radioOneTimeButton.classList.contains('rc-radio--active');
              oneTimeList.style.display = isOneTimeActive ? 'block' : 'none';
              subscriptionList.style.display = !isOneTimeActive ? 'block' : 'none';

              // FORCE both dynamic pricing containers to be visible with explicit styling
              oneTimePricing.container.style.display = 'block';
              oneTimePricing.container.style.visibility = 'visible';
              oneTimePricing.container.style.opacity = '1';

              subscriptionPricing.container.style.display = 'block';
              subscriptionPricing.container.style.visibility = 'visible';
              subscriptionPricing.container.style.opacity = '1';

              console.log('Applied visibility styles to both containers');

              // Debug: Log container positions after a short delay
              setTimeout(() => {
                const oneTimeRect = oneTimePricing.container.getBoundingClientRect();
                const subRect = subscriptionPricing.container.getBoundingClientRect();

                console.log('Container positions:', {
                  onetime: { width: oneTimeRect.width, height: oneTimeRect.height, top: oneTimeRect.top },
                  subscription: { width: subRect.width, height: subRect.height, top: subRect.top },
                });
              }, 200);

              // Initial price updates
              setTimeout(() => {
                console.log('Updating initial prices...');
                oneTimePricing.updatePrice();
                subscriptionPricing.updatePrice();

                // Debug: Check if content was added
                setTimeout(() => {
                  console.log('Container contents:', {
                    onetime: oneTimePricing.container.textContent,
                    subscription: subscriptionPricing.container.textContent,
                  });
                }, 100);
              }, 100);

              // Watch for third-party app adding sale price elements
              const salePriceObserver = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                  // Check if span.price__regular was added
                  if (mutation.addedNodes.length > 0) {
                    const addedSalePrice = Array.from(mutation.addedNodes).some(
                      (node) =>
                        node.nodeType === 1 &&
                        (node.classList?.contains('price__regular') || node.querySelector?.('span.price__regular'))
                    );

                    if (addedSalePrice) {
                      setTimeout(() => {
                        updateWidgetPriceLabels();
                        oneTimePricing.updatePrice();
                        subscriptionPricing.updatePrice();
                      }, 50);
                      break;
                    }
                  }
                }
              });

              // Observe both radio buttons for sale price additions
              salePriceObserver.observe(radioOneTimeButton, { childList: true, subtree: true });
              salePriceObserver.observe(radioSubscriptionButton, { childList: true, subtree: true });

              // Add click handlers to toggle visibility and update prices
              radioOneTimeButton.addEventListener('click', function () {
                oneTimeList.style.display = 'block';
                subscriptionList.style.display = 'none';
                setTimeout(() => {
                  updateWidgetPriceLabels();
                  oneTimePricing.updatePrice();
                }, 50);
              });

              radioSubscriptionButton.addEventListener('click', function () {
                oneTimeList.style.display = 'none';
                subscriptionList.style.display = 'block';
                setTimeout(() => {
                  updateWidgetPriceLabels();
                  subscriptionPricing.updatePrice();
                }, 50);
              });
            }, 100);
          }
        }
      });

      observer.observe(document.body, { attributes: true, childList: true, subtree: true });

      // NEW: Periodic price maintenance check (safety net) - optimized
      function periodicPriceMaintenance() {
        const atcButtonText = domCache.addToCartButton;
        const activeRadio = domCache.getActiveRadio();

        if (atcButtonText && activeRadio) {
          const buttonText = atcButtonText.textContent.trim();

          // If button shows plain "Add to Cart" or "Add to cart" but we have an active radio, restore pricing
          if (buttonText === 'Add to Cart' || buttonText === 'Add to cart') {
            console.log('Periodic maintenance: Restoring missing pricing');
            updatePricesFromActiveRadio();
          }
        }
      }

      // Run periodic maintenance every 3 seconds (reduced frequency for better performance)
      setInterval(periodicPriceMaintenance, 3000);

      // These listeners are now consolidated above for better performance

      // Force-open first product accordion on load
      function openFirstProductAccordion() {
        try {
          const firstDetails = document.querySelector('.product__accordion details');
          if (!firstDetails) return;
          if (!firstDetails.hasAttribute('open')) firstDetails.setAttribute('open', '');
          const summaryEl = firstDetails.querySelector('summary');
          if (summaryEl) summaryEl.setAttribute('aria-expanded', 'true');
        } catch (e) {
          console.warn('Failed to open first product accordion', e);
        }
      }
      // Run immediately and once again shortly after to survive late DOM mutations
      setTimeout(openFirstProductAccordion, 0);
      setTimeout(openFirstProductAccordion, 300);
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["redirect-product"]) return;
  try {
    
  switch (window.location.pathname) {
    case '/products/chewpark':
      window.location.href = '/products/gum';
      break;
    case '/products/slim-pouches':
      window.location.href = '/products/pouches';
      break;
    case '/products/kapsel-pouches':
      window.location.href = '/products/breakers';
      break;
    case '/products/nicotinelozenge':
      window.location.href = '/products/lozenge';
      break;
    case '/products/nicotinelozengeold':
      window.location.href = '/products/lozenge';
      break;
    case '/products/insurance-protection':
      window.location.href = '/';
      break;
  }

  } catch(e) { console.error(e); }
})();
})();
